import React, {useState} from "react";
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import IconButtonSetting from "../../../../../../../components/Button/IconButtonSetting";

import { Struct_TableData } from "./Get_Struct_table";


export default function Dia_Struct_Variants() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
<IconButton onClick={handleOpen} size="small" >
            <IconButtonSetting />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

    title='Obesity Genes - Variants'

    content={ <Struct_TableData />}

/>

</>
)}